module.exports = __webpack_public_path__ + "static/grid-c22240fd442a5ada2fbe789fc8197e8a.png";